/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BillingGroupTypeEnum = "Manual" | "SSO" | "%future added value";
export type SsoAdminPortalButton_billingGroup = {
    readonly id?: string | undefined;
    readonly type?: BillingGroupTypeEnum | null | undefined;
    readonly ssoAdminPortalLink?: ({
        readonly __typename: "SsoAdminPortalLink";
        readonly link: string;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null | undefined;
    readonly message?: string | null | undefined;
    readonly statusCode?: number | null | undefined;
    readonly " $refType": "SsoAdminPortalButton_billingGroup";
};
export type SsoAdminPortalButton_billingGroup$data = SsoAdminPortalButton_billingGroup;
export type SsoAdminPortalButton_billingGroup$key = {
    readonly " $data"?: SsoAdminPortalButton_billingGroup$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SsoAdminPortalButton_billingGroup">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SsoAdminPortalButton_billingGroup",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "ssoAdminPortalLink",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "link",
                                        "storageKey": null
                                    }
                                ],
                                "type": "SsoAdminPortalLink",
                                "abstractKey": null
                            },
                            (v0 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "type": "BillingGroup",
                "abstractKey": null
            },
            (v0 /*: any*/)
        ],
        "type": "BillingGroupErrorable",
        "abstractKey": "__isBillingGroupErrorable"
    } as any;
})();
(node as any).hash = 'f0520bd4990fd2b38d4b564c76a0c78b';
export default node;
